import { InfoOutlineIcon } from '@chakra-ui/icons';
import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import React from 'react';

import { finleyBuffer } from '@finley-technologies/common';
import { generateXlsx2CsvExtractConfigFromXLSX } from '@finley-technologies/tape-sanitizer';

import { ConfigureParams } from './types';
import { FileUploadButton } from '../calcAgentQA/FileUploadButton';

type Props = {
  onAutoConfigure: (configuration: ConfigureParams) => void;
};
export const AutoConfigureXlsx2CsvPanel = ({ onAutoConfigure }: Props) => {
  return (
    <Box mb="2">
      <Flex alignItems="center" mb="2">
        <Text mr="2">Generate config from Xlsx template</Text>
        <Tooltip label='Input custom field names in cells of template with "FINLEY_" prefix'>
          <InfoOutlineIcon />
        </Tooltip>
      </Flex>

      <FileUploadButton
        allowedExtensions={['xlsx']}
        buttonText="Upload Template"
        modalHeaderText="Upload Template: Xlsx2Csv Extract"
        handleFile={(arrayBuffer: ArrayBuffer) => {
          const buffer = finleyBuffer.fromArrayBuffer(arrayBuffer);
          const generatedConfig = generateXlsx2CsvExtractConfigFromXLSX(buffer);
          onAutoConfigure({ ...generatedConfig, operation: 'xlsx2csv' });
        }}
      />
    </Box>
  );
};
